/*
 * matomoTracker.js 07.02.2018
 *
 * (c) 2018 ergovia GmbH
 */

import {LOGIN_SUCCEEDED, LOGOUT} from '../actions/types';

/**
 *
 * @return {Middleware} Middleware zum Tracken von User-Events
 */
window._paq = [];

// Liste von Redux Actions(-Typen), die wir nicht in Matomo berücksichtigen wollen
const actionTypeBlacklist = [LOGIN_SUCCEEDED, LOGOUT];

const matomoEventTracker = () => next => action => {
    const nextState = next(action),
        actionType = action.type,
        userIdent = window.sessionStorage.getItem('sessionIdent');

    if (!actionTypeBlacklist.includes(action.type)) {

        // Identify correct action value
        const actionValue =
            action.by ||
            action.start ||
            action.end ||
            // Die "Null" wird selbst als String im Matomo nicht dargestellt, daher das zusätzliche Zeichen.
            // Die Klammern sind zur Auswertung der expression notwendig.
            (action.value === 0 ? `.${action.value}` : action.value) ||
            '<nodata>';

        window._paq.push(['setUserId', `${userIdent}`]);
        window._paq.push(['trackEvent', actionType, actionValue]);
    }
    return nextState;
};



export default matomoEventTracker;



// WEBPACK FOOTER //
// ./src/de/ergovia/middleware/matomoTracker.js